const { Profanity, CensorType } = require('@2toad/profanity');

const SUPPORTED_LANGUAGES = [
  'en',
  'ru',
  'zh',
  'hi',
  'es',
  'fr',
  'ar',
  'pt',
  // 'tr', // Turkish is the one language we support that's not supported by the filter
  'ko',
  'de',
];

const WHOLE_WORD_WHITELIST = [
  'balls',
  'bum',
  'butt',
  'chink',
  'cock',
  'cocks',
  'crap',
  'fanny',
  'hoar',
  'hoes',
  'pawn',
  'poop',
  'pron',
  'sadist',
  's hit',
];

const PARTIAL_WORD_WHITELIST = [
  ...WHOLE_WORD_WHITELIST,
  'arse',
  'ass',
  'asses',
  'butts',
  'cipa',
  'cum',
  'cums',
  'hore',
  'jap',
  'nob',
  'sex',
  'spac',
  'tit',
];

const whole_word_filter = new Profanity({
  languages: SUPPORTED_LANGUAGES,
  wholeWord: true,
});
whole_word_filter.removeWords(WHOLE_WORD_WHITELIST);

const partial_word_filter = new Profanity({
  languages: SUPPORTED_LANGUAGES,
  wholeWord: false,
});
partial_word_filter.removeWords(PARTIAL_WORD_WHITELIST);

const censor = (text, locales) =>
  whole_word_filter.censor(
    // only censor partial words in English
    locales.includes('en') ? partial_word_filter.censor(text, CensorType.Word, locales) : text,
    CensorType.Word,
    locales
  );

const test = (text, locales) =>
  locales.includes('en')
    ? // only test partial words in English
      whole_word_filter.exists(text, locales) || partial_word_filter.exists(text, locales)
    : whole_word_filter.exists(text, locales);

module.exports = {
  censor,
  SUPPORTED_LANGUAGES,
  test,
};
